(function () {
  var el = document.getElementById('salut-gtag');
  var id = el && el.getAttribute('data-ga4-id');

  window.salutTrack = function (eventName, params) {
    if (typeof window.gtag === 'function') window.gtag('event', eventName, params || {});
  };

  if (!id) return;
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () { window.dataLayer.push(arguments); };
  window.gtag('js', new Date());
  window.gtag('config', id);
})();
